import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { price } from 'utils/helpers';
import {
  getSelectedPaymentTypes,
  getSurchargeAmount,
  getTransactionFee,
} from 'redux/selectors/current_booking';

const PaymentSurcharge = ({ className = 'text-xxx-small' }) => {
  const selectedPaymentType = useSelector(getSelectedPaymentTypes);
  const transactionFee = useSelector(getTransactionFee);
  const surchargeAmount = useSelector(getSurchargeAmount);

  if (!surchargeAmount || isEmpty(selectedPaymentType)) {
    return null;
  }

  // Google Pay doesn't want to be associated with the surcharge
  const isGooglePay = selectedPaymentType.payment_method === 'google_pay';
  const paymentName = isGooglePay ? 'this' : selectedPaymentType.name;
  const defaultMessage = `A ${transactionFee}% surcharge applies to ${paymentName} transactions (${price(
    surchargeAmount
  )}).`;

  if (isGooglePay) {
    return (
      <div className={className}>
        <p>{defaultMessage}</p>
        <p>
          Kindly be aware that the card processing fee is not related to Google
          Pay, but solely to cover our third-party merchant fees.
        </p>
      </div>
    );
  }

  return (
    <div className={className}>
      <p>{defaultMessage}</p>
    </div>
  );
};

PaymentSurcharge.propTypes = {
  className: PropTypes.string,
};

export default PaymentSurcharge;
